import type { CardsTranslations } from "../interfaces/cards";

export const cardsTranslations: CardsTranslations = {
  edit_alias_modal_title: "Editar Alias do Cartão",
  edit_alias_modal_description:
    "O alias é um nome personalizado que ajuda você a identificar facilmente este cartão em sua lista.",
  edit_alias_label: "Alias",
  edit_alias_placeholder: "Digite um alias para o cartão",
  edit_alias_error_required: "O alias é obrigatório",
  edit_alias_error_min_length: "O alias deve ter pelo menos 1 caractere",
  edit_alias_error_max_length: "O alias não pode ter mais de 26 caracteres",
  edit_alias_error_load_data: "Erro ao carregar os dados do cartão",
  edit_alias_button_update: "Atualizar",
  edit_alias_button_cancel: "Cancelar",
  edit_alias_success_message: "O alias foi atualizado com sucesso",
  edit_alias_error_message: "Erro ao atualizar o alias do cartão",
  card_detail_title: "Cartão",
  card_detail_back_to_list: "Voltar à lista",
  card_detail_status_label: "Status:",
  card_detail_select_status: "Selecionar status",
  card_detail_loading: "Carregando informações do cartão...",
  card_detail_error_load: "Erro ao carregar o cartão",
  card_detail_error_load_movements: "Erro ao carregar os movimentos",
  card_detail_error_load_more_movements: "Erro ao carregar mais movimentos",
  card_detail_error_generate_url: "Erro ao gerar a URL de visualização",
  card_detail_status_update_success: "Status do cartão atualizado com sucesso",
  card_detail_status_update_error: "Erro ao atualizar o status do cartão",
  movements_title: "Movimentos",
  movements_loading: "Carregando movimentos...",
  movements_refresh: "Atualizar",
  movements_empty: "Não há movimentos para exibir",
  movements_load_more: "Mostrar mais movimentos",
  movements_loading_more: "Carregando mais movimentos...",
  movements_show_more_aria: "Mostrar mais movimentos",
  movements_status_pending: "Pendente",
  movements_status_completed: "Concluído",
  movements_status_failed: "Falhou",
  movements_status_reversed: "Revertido",
  txn_detail_title: "Detalhe do movimento",
  txn_detail_subtitle: "Detalhe da transação",
  txn_detail_loading: "Carregando detalhe...",
  txn_detail_error_title: "Não foi possível carregar o movimento",
  txn_detail_error_description: "Ocorreu um problema ao obter o detalhe. Tente novamente.",
  txn_detail_retry: "Tentar novamente",
  txn_detail_close: "Fechar",
  txn_detail_section_movement: "Movimento",
  txn_detail_section_performed_by: "Realizado por",
  txn_detail_section_where: "Onde",
  txn_detail_section_conversion: "Conversão de moeda",
  txn_detail_field_type: "Tipo",
  txn_detail_field_operation: "Operação",
  txn_detail_field_description: "Descrição",
  txn_detail_field_merchant: "Estabelecimento",
  txn_detail_field_category: "Categoria",
  txn_detail_field_location: "Localização",
  txn_detail_field_terminal: "Terminal / POS",
  txn_detail_field_exchange_rate: "Taxa de câmbio",
  txn_detail_field_spot_variation: "Variação spot",
  txn_detail_field_performed_by_name: "Nome",
  txn_detail_field_performed_by_email: "E-mail",
  txn_detail_operation_credit: "Crédito (+)",
  txn_detail_operation_debit: "Débito (−)",
  txn_type_purchase: "Compra",
  txn_type_topup: "Recarga",
  txn_type_deposit: "Depósito",
  txn_type_refund: "Reembolso",
  txn_type_atm_withdrawal: "Saque em caixa",
  txn_type_withdrawal: "Saque",
  txn_type_fee: "Taxa",
  txn_type_transfer: "Transferência",
  txn_type_reversal: "Estorno",
  txn_type_adjustment: "Ajuste",
  mcc_category_taxi_rideshare: "Táxis",
  mcc_category_public_transit: "Transporte público",
  mcc_category_airlines: "Companhias aéreas",
  mcc_category_travel: "Viagens e agências",
  mcc_category_car_rental: "Aluguel de carros",
  mcc_category_lodging: "Hospedagem",
  mcc_category_groceries: "Supermercados",
  mcc_category_restaurants: "Restaurantes",
  mcc_category_fast_food: "Fast food",
  mcc_category_bars: "Bares",
  mcc_category_liquor: "Bebidas",
  mcc_category_fuel: "Combustível",
  mcc_category_automotive: "Automotivo",
  mcc_category_apparel: "Vestuário",
  mcc_category_shoes: "Calçados",
  mcc_category_jewelry: "Joalheria",
  mcc_category_electronics: "Eletrônicos",
  mcc_category_department_stores: "Lojas de departamento",
  mcc_category_discount_stores: "Lojas de desconto",
  mcc_category_furniture: "Móveis",
  mcc_category_home_improvement: "Casa e construção",
  mcc_category_books_stationery: "Livros e papelaria",
  mcc_category_sporting_goods: "Artigos esportivos",
  mcc_category_toys_hobby: "Brinquedos e hobbies",
  mcc_category_gifts: "Presentes",
  mcc_category_florist: "Floriculturas",
  mcc_category_pets: "Pets",
  mcc_category_cosmetics: "Cosméticos",
  mcc_category_music_media: "Música e vídeo",
  mcc_category_general_retail: "Compras gerais",
  mcc_category_wholesale: "Atacado",
  mcc_category_technology: "Tecnologia",
  mcc_category_telecom: "Telecomunicações",
  mcc_category_utilities: "Serviços públicos",
  mcc_category_entertainment: "Entretenimento",
  mcc_category_gambling: "Apostas e cassinos",
  mcc_category_medical: "Serviços médicos",
  mcc_category_pharmacy: "Farmácias",
  mcc_category_education: "Educação",
  mcc_category_financial: "Serviços financeiros",
  mcc_category_insurance: "Seguros",
  mcc_category_real_estate: "Imóveis",
  mcc_category_professional_services: "Serviços profissionais",
  mcc_category_personal_care: "Cuidados pessoais",
  mcc_category_repair_services: "Reparos",
  mcc_category_cleaning_laundry: "Limpeza e lavanderia",
  mcc_category_contractors: "Empreiteiros",
  mcc_category_shipping: "Envios",
  mcc_category_government: "Governo",
  mcc_category_charity: "Doações",
  mcc_category_membership_orgs: "Organizações",
  mcc_category_services_other: "Outros serviços",
  card_visual_loading: "Carregando cartão...",
  card_visual_view_title: "Visualização do cartão",
  card_visual_copy_number: "Copiar número",
  card_visual_expires: "Expira",
  card_visual_cvv: "CVV",
  update_status_modal_title: "Alterar Status",
  update_status_modal_button_cancel: "Cancelar",
  update_status_modal_button_confirm: "Alterar status",
  update_status_modal_warning_title: "Alterar status do cartão",
  update_status_modal_confirmation_message: "Tem certeza de que deseja alterar o status do cartão de",
  update_status_modal_to: "para",
  status_active: "Ativa",
  status_frozen: "Congelada",
  status_disabled: "Desabilitada",
  status_deleted: "Excluída",
  status_pending_review: "Pendente de revisão",
  table_header_name: "Nome",
  table_header_alias: "Alias",
  table_header_provider: "Provedor",
  table_header_last4: "Últimos 4 dígitos",
  table_header_type: "Tipo",
  table_header_product: "Produto",
  table_header_status: "Status",
  table_header_actions: "Ações",
  table_showing_cards: "Mostrando",
  table_showing_cards_singular: "cartão",
  table_showing_cards_plural: "cartões",
  table_showing_total: "Total",
  table_show: "Mostrar:",
  table_tooltip_view_detail: "Ver detalhes do cartão",
  table_tooltip_edit: "Editar cartão",
  table_tooltip_view_detail_en: "Card detail",
  table_tooltip_edit_en: "Edit card",
  type_credit: "Crédito",
  type_debit: "Débito",
  type_prepaid: "Pré-pago",
  product_virtual: "Virtual",
  product_physical: "Física",
  provider_visa: "Visa",
  provider_mastercard: "Mastercard",
  provider_amex: "Amex",
  provider_discover: "Discover",
  provider_other: "Outro",
  filters_title: "Filtros",
  filters_search_alias_placeholder: "Buscar por alias...",
  filters_clear: "Limpar Filtros",
  filters_select_status: "Selecionar status",
  filters_select_provider: "Selecionar provedor",
  filters_select_type: "Selecionar tipo",
  filters_select_product: "Selecionar produto",
  filters_cards_created: "CARTÕES CRIADOS",
  cards_not_found: "Nenhum cartão encontrado",
  cards_loading: "Carregando cartões...",
  cards_error_load: "Erro ao carregar os cartões",
  pagination_first_page: "Primeira página",
  pagination_previous_page: "Página anterior",
  pagination_next_page: "Próxima página",
  pagination_last_page: "Última página",
  pagination_total_pages: "Total de páginas",
  identities_table_header_name: "Nome",
  identities_table_header_document_number: "Número do documento",
  identities_table_header_nationality: "Nacionalidade",
  identities_table_header_type: "Tipo",
  identities_table_header_status: "Status",
  identities_table_header_actions: "Ações",
  identities_table_header_cards: "Cartões",
  identities_table_showing: "Mostrando",
  identities_table_showing_singular: "identidade",
  identities_table_showing_plural: "identidades",
  identities_table_show: "Mostrar:",
  identities_table_tooltip_view_detail: "Ver detalhes da identidade",
  identities_table_tooltip_view_detail_en: "Identity detail",
  identities_table_tooltip_create_card: "Criar cartão",
  identities_table_tooltip_create_card_en: "Create card",
  identities_type_select: "Selecionar",
  identities_status_active: "Ativa",
  identities_status_pending_review: "Pendente de revisão",
  identities_status_rejected: "Rejeitada",
  identities_header_new_identity_person: "+ Nova identidade (pessoa)",
  identities_header_new_identity_business: "+ Nova identidade (empresa)",
  identities_header_filter_select_type: "Selecionar tipo",
  identities_header_identities_created: "IDENTIDADES CRIADAS",
  identities_not_found: "Nenhuma identidade encontrada",
  identities_loading: "Carregando identidades...",
  identities_error_load: "Erro ao carregar as identidades",
  identities_error_create_card: "Erro ao criar o cartão",
  create_identity_modal_title: "Nova Identidade (pessoa)",
  create_identity_modal_button_cancel: "Cancelar",
  create_identity_modal_button_create: "Criar titular",
  create_identity_section_organization_title: "Identidade da Organização",
  create_identity_section_organization_description:
    "Indique se esta identidade pertence à própria organização (sua identidade corporativa). Pode ser individual (pessoa física) ou business (empresa). Se enviar outra, substituirá a anterior.",
  create_identity_section_organization_checkbox: "Esta identidade pertence à organização",
  create_identity_section_identity_title: "Informações da Identidade",
  create_identity_section_identity_description: "Dados pessoais e de contato da identidade",
  create_identity_section_address_title: "Endereço",
  create_identity_section_address_description: "Informações de localização e endereço",
  create_identity_label_type: "Tipo de Identidade",
  create_identity_label_email: "Email",
  create_identity_label_first_name: "Nome",
  create_identity_label_last_name: "Sobrenome",
  create_identity_label_birthdate: "Data de Nascimento",
  create_identity_label_gender: "Gênero",
  create_identity_label_nationality: "Nacionalidade",
  create_identity_label_personal_id_type: "Tipo de Documento",
  create_identity_label_personal_id_number: "Número do Documento",
  create_identity_label_phone: "Telefone",
  create_identity_label_country: "País",
  create_identity_label_city: "Cidade",
  create_identity_label_postal_code: "Código Postal",
  create_identity_label_address_type: "Tipo de Endereço",
  create_identity_label_address_line_1: "Endereço Linha 1",
  create_identity_label_address_line_2: "Endereço Linha 2",
  create_identity_label_state: "Estado/Província",
  create_identity_gender_male: "Masculino",
  create_identity_gender_female: "Feminino",
  create_identity_gender_other: "Outro",
  create_identity_id_type_cc: "CC - Cédula de Cidadania",
  create_identity_id_type_ce: "CE - Cédula de Estrangeiro",
  create_identity_id_type_passport: "PASSPORT - Passaporte",
  create_identity_id_type_nit: "NIT - Número de Identificação Tributária",
  create_identity_id_type_ppt: "PPT - Permissão de Proteção Temporária",
  create_identity_id_type_ine: "INE - Carteira de Eleitor",
  create_identity_id_type_rfc: "RFC - Registro Federal de Contribuintes",
  create_identity_id_type_dni: "DNI - Documento Nacional de Identidade",
  create_identity_id_type_le: "LE - Caderneta de Alistamento",
  create_identity_id_type_lc: "LC - Caderneta Cívica",
  create_identity_id_type_ci: "CI - Cédula de Identidade",
  create_identity_id_type_rg: "RG - Registro Geral",
  create_identity_id_type_cnh: "CNH - Carteira Nacional de Habilitação",
  create_identity_id_type_national_id: "NATIONAL_ID - Documento de Identidade Nacional",
  create_identity_id_type_driver_license: "DRIVER_LICENSE - Carteira de Motorista",
  create_identity_id_type_residence_permit: "RESIDENCE_PERMIT - Permissão de Residência",
  create_identity_id_type_cuil: "CUIL - Código Único de Identificação Trabalhista",
  create_identity_id_type_cpf: "CPF - Cadastro de Pessoas Físicas",
  create_identity_id_type_cnpj: "CNPJ - Cadastro Nacional da Pessoa Jurídica",
  create_identity_id_type_ruc: "RUC - Registro Único de Contribuintes",
  create_identity_id_type_rut: "RUT - Registro Único Tributário",
  create_identity_id_type_tax_id: "TAX_ID - Identificação Fiscal",
  create_identity_label_id_country: "País do documento",
  create_identity_label_identification_type: "Tipo de documento",
  create_identity_label_identification_number: "Número do documento",
  create_identity_address_type_registration: "REGISTRATION",
  create_identity_address_type_shipping: "SHIPPING",
  create_identity_address_type_billing: "BILLING",
  create_identity_address_type_kyc: "KYC",
  create_identity_error_address_line_1_required: "O endereço linha 1 é obrigatório",
  create_identity_error_address_line_2_required: "O endereço linha 2 é obrigatório",
  create_identity_error_city_required: "A cidade é obrigatória",
  create_identity_error_state_required: "O estado/província é obrigatório",
  create_identity_error_country_required: "O país é obrigatório",
  create_identity_error_postal_code_required: "O código postal é obrigatório",
  create_identity_error_email_required: "O email é obrigatório",
  create_identity_error_email_invalid: "O email não é válido",
  create_identity_error_first_name_required: "O nome é obrigatório",
  create_identity_error_last_name_required: "O sobrenome é obrigatório",
  create_identity_error_birthdate_required: "A data de nascimento é obrigatória",
  create_identity_error_gender_required: "O gênero é obrigatório",
  create_identity_error_nationality_required: "A nacionalidade é obrigatória",
  create_identity_error_personal_id_number_required: "O número do documento é obrigatório",
  create_identity_error_personal_id_type_required: "O tipo de documento é obrigatório",
  create_identity_error_id_type_invalid_for_country:
    "O tipo de documento não é válido para a nacionalidade selecionada",
  create_identity_error_cpf_digits: "O CPF deve ter 11 dígitos.",
  create_identity_error_cnpj_length: "O CNPJ deve ter 14 caracteres.",
  create_identity_error_phone_required: "O telefone é obrigatório",
  create_business_identity_modal_title: "Nova Identidade (empresa)",
  create_business_identity_section_company_title: "Informações da Empresa",
  create_business_identity_section_company_description: "Dados comerciais e legais da empresa",
  create_business_identity_section_owner_title: "Informações do Representante Legal",
  create_business_identity_section_owner_description: "Dados pessoais do representante legal da empresa",
  create_business_identity_section_owner_address_title: "Endereço do Representante Legal",
  create_business_identity_section_owner_address_description:
    "Informações de localização e endereço do representante legal",
  create_business_identity_section_company_address_title: "Endereço da Empresa",
  create_business_identity_section_company_address_description:
    "Informações de localização e endereço da empresa",
  create_business_identity_label_name: "Nome Comercial",
  create_business_identity_label_business_type: "Tipo de Entidade",
  create_business_identity_label_legal_name: "Razão Social",
  create_business_identity_label_tax_id: "NIT / Número de Identificação Tributária",
  create_business_identity_label_incorporation_date: "Data de Incorporação",
  create_business_identity_label_country_name: "País (Nome)",
  create_business_identity_label_country_code: "Código do País (ISO3)",
  create_business_identity_label_identification_type: "Tipo de documento (empresa)",
  create_business_identity_label_identification_number: "Número do documento (empresa)",
  create_business_identity_label_owner_name: "Nome do Representante Legal",
  create_business_identity_label_owner_id_type: "Tipo de Documento do Representante Legal",
  create_business_identity_label_owner_id_number: "Número do Documento do Representante Legal",
  create_business_identity_label_owner_address_line1: "Endereço Linha 1",
  create_business_identity_label_owner_city: "Cidade",
  create_business_identity_label_owner_state: "Estado/Província",
  create_business_identity_label_owner_postal_code: "Código Postal",
  create_business_identity_label_owner_country_code: "Código do País (ISO3)",
  create_business_identity_business_type_llc: "LLC",
  create_business_identity_business_type_sa: "S.A.",
  create_business_identity_business_type_corp: "Corp",
  create_business_identity_business_type_sas: "S.A.S.",
  create_business_identity_business_type_sociedad_anonima: "Sociedade Anônima",
  create_business_identity_business_type_sociedad_limitada: "Sociedade Limitada",
  create_business_identity_business_type_corporacion: "Corporação",
  create_business_identity_business_type_sa_de_cv: "S.A. de C.V.",
  create_business_identity_business_type_s_de_rl_de_cv: "S. de R.L. de C.V.",
  create_business_identity_business_type_sapi_de_cv: "S.A.P.I. de C.V.",
  create_business_identity_business_type_sc: "S.C.",
  create_business_identity_business_type_persona_fisica_ae: "Pessoa física com atividade empresarial",
  create_business_identity_id_type_ssn: "SSN - Social Security Number",
  create_business_identity_id_type_rut: "RUT - Registro Único Tributário",
  create_business_identity_error_name_required: "O nome comercial é obrigatório",
  create_business_identity_error_business_type_required: "O tipo de entidade é obrigatório",
  create_business_identity_error_legal_name_required: "A razão social é obrigatória",
  create_business_identity_error_tax_id_required: "O NIT/Número de identificação tributária é obrigatório",
  create_business_identity_error_tax_id_invalid: "O NIT deve conter apenas letras e números",
  create_business_identity_error_incorporation_date_required: "A data de incorporação é obrigatória",
  create_business_identity_error_country_name_required: "O nome do país é obrigatório",
  create_business_identity_error_country_code_required: "O código do país é obrigatório",
  create_business_identity_error_owner_name_required: "O nome do representante legal é obrigatório",
  create_business_identity_error_owner_id_type_required:
    "O tipo de documento do representante legal é obrigatório",
  create_business_identity_error_owner_id_number_required:
    "O número do documento do representante legal é obrigatório",
  create_business_identity_error_owner_address_line1_required:
    "O endereço do representante legal é obrigatório",
  create_business_identity_error_owner_city_required: "A cidade do representante legal é obrigatória",
  create_business_identity_error_owner_state_required: "O estado do representante legal é obrigatório",
  create_business_identity_error_owner_postal_code_required:
    "O código postal do representante legal é obrigatório",
  create_business_identity_error_owner_country_code_required:
    "O código do país do representante legal é obrigatório",
  identity_detail_title: "Detalhe da Identidade",
  identity_detail_back_to_list: "Voltar à lista",
  identity_detail_loading: "Carregando informações da identidade...",
  identity_detail_error_load: "Erro ao carregar a identidade",
  identity_detail_status_label: "Status:",
  identity_detail_section_personal_title: "Informações Pessoais",
  identity_detail_section_address_title: "Endereço",
  identity_detail_section_kyc_title: "Status KYC",
  identity_detail_label_full_name: "Nome completo",
  identity_detail_label_email: "Email",
  identity_detail_label_phone: "Telefone",
  identity_detail_label_gender: "Gênero",
  identity_detail_label_document_type: "Tipo de documento",
  identity_detail_label_document_number: "Número do documento",
  identity_detail_label_address_line_1: "Endereço linha 1",
  identity_detail_label_address_line_2: "Endereço linha 2",
  identity_detail_label_city: "Cidade",
  identity_detail_label_country: "País",
  identity_detail_label_created_at: "Data de criação",
  identity_detail_not_specified: "Não especificado",
  identity_detail_gender_male: "Masculino",
  identity_detail_gender_female: "Feminino",
  identity_detail_gender_other: "Outro",
  identity_detail_kyc_status_pending: "Pendente",
  identity_detail_kyc_status_in_review: "Em revisão",
  identity_detail_kyc_status_verified: "Verificado",
  identity_detail_kyc_status_rejected: "Rejeitado",
  identity_detail_kyc_status_expired: "Expirado",
  organizations_table_header_name: "Nome",
  organizations_table_header_email: "Email",
  organizations_table_header_phone: "Telefone",
  organizations_table_header_status: "Status",
  organizations_table_header_card_provider: "Provedor de Cartões",
  organizations_table_header_actions: "Ações",
  organizations_table_showing: "Mostrando",
  organizations_table_showing_singular: "organização",
  organizations_table_showing_plural: "organizações",
  organizations_table_show: "Mostrar:",
  organizations_table_tooltip_view_detail: "Ver detalhes da organização",
  organizations_table_tooltip_view_detail_en: "Organization detail",
  organizations_table_tooltip_edit: "Editar organização",
  organizations_table_tooltip_edit_en: "Edit organization",
  organizations_table_tooltip_delete: "Excluir organização",
  organizations_table_tooltip_delete_en: "Delete organization",
  organizations_status_active: "Ativo",
  organizations_status_inactive: "Inativo",
  organizations_status_suspended: "Suspenso",
  organizations_status_pending: "Pendente",
  organizations_provider_bloque: "Coloca Cards",
  organizations_provider_crypto_mate: "Coloca Crypto",
  organizations_provider_na: "N/A",
  organizations_header_new_organization: "+ Nova organização",
  organizations_header_organizations_created: "ORGANIZAÇÕES CRIADAS",
  organizations_not_found: "Nenhuma organização encontrada",
  organizations_loading: "Carregando organizações...",
  organizations_error_load: "Erro ao carregar as organizações",
  organizations_error_update: "Erro ao atualizar a organização",
  organizations_error_delete: "Erro ao excluir a organização",
  organizations_error_create: "Erro ao criar a organização",
  organizations_success_update: "Organização atualizada com sucesso",
  organizations_success_create: "Organização criada com sucesso",
  organization_detail_modal_title: "Detalhe da Organização",
  organization_detail_error_load: "Erro ao carregar os detalhes da organização",
  organization_detail_status_label: "Status:",
  organization_detail_section_basic_title: "Informações Básicas",
  organization_detail_section_additional_title: "Informações Adicionais",
  organization_detail_label_name: "Nome:",
  organization_detail_label_slug: "Slug:",
  organization_detail_label_email: "Email:",
  organization_detail_label_phone: "Telefone:",
  organization_detail_label_card_provider: "Provedor de Cartões:",
  organization_detail_label_created_at: "Criado:",
  organization_detail_label_updated_at: "Atualizado:",
  organization_detail_not_available: "N/A",
  update_organization_modal_title: "Atualizar Organização",
  update_organization_modal_button_cancel: "Cancelar",
  update_organization_modal_button_update: "Atualizar",
  update_organization_modal_description: "Dados básicos da organização",
  update_organization_label_card_provider: "Provedor de Cartões",
  update_organization_label_status: "Status",
  update_organization_label_name: "Nome",
  update_organization_label_email: "Email",
  update_organization_label_slug: "Slug",
  update_organization_label_phone: "Telefone",
  update_organization_info_phone: "Número internacional com código do país (sem o símbolo +)",
  update_organization_error_load_data: "Erro ao carregar os dados da organização",
  update_organization_validation_name_required: "O nome é obrigatório",
  update_organization_validation_name_min_length: "O nome deve ter pelo menos 2 caracteres",
  update_organization_validation_name_max_length: "O nome não pode ter mais de 255 caracteres",
  update_organization_validation_slug_max_length: "O slug não pode ter mais de 255 caracteres",
  update_organization_validation_email_required: "O email é obrigatório",
  update_organization_validation_email_invalid: "O email não é válido",
  update_organization_validation_email_max_length: "O email não pode ter mais de 255 caracteres",
  update_organization_validation_phone_max_length: "O telefone não pode ter mais de 20 caracteres",
  delete_organization_modal_title: "Excluir Organização",
  delete_organization_modal_button_cancel: "Cancelar",
  delete_organization_modal_button_delete: "Excluir",
  delete_organization_modal_warning: "Esta ação não pode ser desfeita",
  delete_organization_modal_confirmation_message:
    "Tem certeza de que deseja excluir a organização {{organizationName}}? Esta ação excluirá permanentemente todos os dados associados a esta organização.",
  delete_organization_success_modal_title: "Organização Excluída",
  delete_organization_success_modal_button_ok: "OK",
  delete_organization_success_modal_message: "A organização foi excluída com sucesso.",
  create_organization_modal_title: "Nova Organização",
  create_organization_modal_button_cancel: "Cancelar",
  create_organization_modal_button_create: "Criar Organização",
  create_organization_modal_description: "Dados básicos da organização",
  create_organization_info_slug: "Será gerado automaticamente a partir do nome se deixado vazio",
  create_organization_validation_name_required: "O nome é obrigatório",
  create_organization_validation_name_min_length: "O nome deve ter pelo menos 2 caracteres",
  create_organization_validation_name_max_length: "O nome não pode ter mais de 255 caracteres",
  create_organization_validation_slug_max_length: "O slug não pode ter mais de 255 caracteres",
  create_organization_validation_email_required: "O email é obrigatório",
  create_organization_validation_email_invalid: "O email não é válido",
  create_organization_validation_email_max_length: "O email não pode ter mais de 255 caracteres",
  create_organization_validation_phone_max_length: "O telefone não pode ter mais de 20 caracteres",
  cards_header_title_organizations: "Organizações",
  cards_header_title_identities: "Titulares",
  cards_header_title_cards: "Cartões",
  cards_header_title_movements: "Movimentos",
  cards_header_title_configuration: "Configuração",
  cards_header_title_pockets: "Compartimentos",
  cards_tab_label_organizations: "Organizações",
  cards_tab_label_identities: "Titulares",
  cards_tab_label_cards: "Cartões",
  cards_tab_label_pockets: "Compartimentos",
  balance_refresh_btn: "Atualizar saldo",
  two_factor_required_to_create_card: "Ative a autenticação em duas etapas para criar cartões",
  two_factor_required_to_view_card: "Ative a autenticação em duas etapas para ver os dados do cartão",
  two_factor_required_to_topup_card: "Ative a autenticação em duas etapas para carregar ou retirar saldo",
  two_factor_required_to_move_card: "Ative a autenticação em duas etapas para mover saldo entre cartões",
  two_factor_required_modal_title: "Autenticação em duas etapas necessária",
  two_factor_required_modal_cancel: "Cancelar",
  two_factor_required_modal_go_to_settings: "Ir para configurações",
  two_factor_challenge_title: "Verifique sua identidade",
  two_factor_challenge_description:
    "Digite o código de 6 dígitos do seu aplicativo autenticador para continuar.",
  two_factor_challenge_submit: "Verificar",
  two_factor_challenge_error_invalid_code: "Código incorreto. Tente novamente.",
  no_permission_contact_admin: "Você não tem permissão para esta ação. Entre em contato com o administrador.",
  wallet_banner_label: "Carteira de cartões · USD",
  wallet_banner_status_active: "Ativo",
  wallet_banner_description:
    "O que você retira de um cartão volta para cá e pode ser carregado em outro na hora.",
  wallet_banner_btn_movements: "Movimentos",
  wallet_banner_topup_coming_soon: "Em breve: recarga direta no saldo principal.",
  wallet_banner_allocation_available: "Na wallet",
  wallet_banner_allocation_available_description:
    "Saldo livre · ainda não alocado em compartimentos ou cartões",
  wallet_banner_allocation_pockets: "Em compartimentos",
  wallet_banner_allocation_pockets_description: "Distribuído entre todos os compartimentos",
  wallet_banner_allocation_cards: "Em cartões",
  wallet_banner_allocation_cards_description: "Carregado em cartões ativos",
  wallet_banner_error_load: "Não foi possível carregar o saldo da carteira de cartões. Tente novamente.",
  wallet_banner_loading: "Carregando saldo...",
  wallet_movements_eyebrow_back: "Cartões",
  wallet_movements_export: "Exportar",
  wallet_movements_refresh: "Atualizar",
  wallet_movements_stat_balance_label: "Na carteira",
  wallet_movements_stat_balance_description: "Disponível total",
  wallet_movements_stat_in_label: "Entrou neste período",
  wallet_movements_stat_in_description: "Recargas e depósitos",
  wallet_movements_stat_out_label: "Saiu neste período",
  wallet_movements_stat_out_description: "Transferências e retiradas",
  wallet_movements_history_title: "Histórico",
  wallet_movements_history_transfer_button: "Transferir",
  wallet_movements_filter_all: "Todos",
  wallet_movements_filter_topup: "Recargas",
  wallet_movements_filter_transfer: "Transferências",
  wallet_movements_filter_withdrawal: "Retiradas",
  wallet_movements_filter_fee: "Taxas",
  pockets_activate_title: "Precisa agrupar cartões por equipe ou projeto?",
  pockets_activate_subtitle:
    "Ative os Compartimentos para compartilhar saldo entre vários cartões e separar orçamentos.",
  pockets_activate_button: "Ativar compartimentos",
  pockets_placeholder_title: "Em breve",
  pockets_placeholder_description:
    "Estamos construindo Compartimentos para que você possa agrupar cartões e compartilhar saldo entre eles.",
  wallet_movements_title: "Movimentos da carteira de cartões",
  wallet_movements_subtitle:
    "Recargas, transferências para compartimentos e cartões, e taxas. Não inclui gastos diretos feitos com cartões.",
  wallet_movements_back: "Voltar aos cartões",
  wallet_movements_breadcrumb: "Movimentos da carteira de cartões",
  wallet_movements_filter_type_label: "Tipo",
  wallet_movements_filter_type_all: "Todos os tipos",
  wallet_movements_filter_direction_label: "Direção",
  wallet_movements_filter_direction_all: "Todas",
  wallet_movements_filter_status_label: "Status",
  wallet_movements_filter_status_all: "Todos os status",
  wallet_movements_filter_date_from: "De",
  wallet_movements_filter_date_to: "Até",
  wallet_movements_filter_clear: "Limpar filtros",
  wallet_movements_type_topup: "Recarga",
  wallet_movements_type_transfer: "Transferência",
  wallet_movements_type_withdrawal: "Retirada",
  wallet_movements_type_fee: "Taxa",
  wallet_movements_type_deposit: "Depósito",
  wallet_movements_type_reversal: "Reversão",
  wallet_movements_type_adjustment: "Ajuste",
  wallet_movements_direction_in: "Entrada",
  wallet_movements_direction_out: "Saída",
  wallet_movements_status_pending: "Pendente",
  wallet_movements_status_completed: "Concluído",
  wallet_movements_status_failed: "Falhou",
  wallet_movements_status_reversed: "Revertido",
  wallet_movements_empty: "Sem movimentos",
  wallet_movements_empty_description:
    "Ainda não há movimentos neste saldo. Quando você fizer uma recarga ou transferência, eles aparecerão aqui.",
  wallet_movements_loading: "Carregando movimentos...",
  wallet_movements_error_load: "Não foi possível carregar os movimentos. Tente novamente.",
  create_card_modal_title: "Criar Cartão",
  create_card_modal_button_cancel: "Cancelar",
  create_card_modal_button_create: "Criar Cartão",
  create_card_modal_info_message: "Criar novo cartão",
  create_card_modal_confirmation_message:
    "Tem certeza de que deseja criar um cartão para a identidade {{identityName}}? Um novo cartão associado a esta identidade será gerado e estará disponível para uso.",
  create_card_success_modal_title: "Cartão Criado",
  create_card_success_modal_button_ok: "OK",
  create_card_success_modal_message: "O cartão foi criado com sucesso.",
  nationality_col: "Colombiana",
  nationality_mex: "Mexicana",
  nationality_arg: "Argentina",
  nationality_chl: "Chilena",
  nationality_per: "Peruana",
  nationality_ecu: "Equatoriana",
  nationality_bra: "Brasileira",
  nationality_pan: "Panamenha",
  nationality_usa: "Americana",
  nationality_esp: "Espanhola",
  card_new_button: "Novo cartão",
  card_new_button_coming_soon: "Em breve: crie cartões diretamente daqui.",
  card_new_requires_eligible_holder: "O titular deve estar ativo e com KYC aprovado para emitir um cartão.",
  holder_new_button: "Novo titular",
  pocket_new_button: "Novo compartimento",
  pocket_new_button_coming_soon: "Em breve: crie compartimentos para agrupar cartões.",
  pocket_new_disabled_tooltip: "Desativado temporariamente",
  pocket_topup_disabled_tooltip: "Desativado temporariamente",
  cards_list_section_title: "Todos os cartões",
  cards_list_results_label: "resultados",
  cards_load_more: "Carregar mais",
  cards_loading_more: "Carregando mais cartões...",
  cards_list_of_total: "de",
  cards_filter_all: "Todos",
  cards_filter_virtual: "Virtuais",
  cards_filter_fisica: "Físicos",
  cards_filter_frozen: "Congelados",
  cards_filter_pending: "Pendentes",
  cards_filter_no_pocket: "Sem compartimento",
  cards_view_list: "Visualização em lista",
  cards_view_grid: "Visualização em grade",
  cards_sort_label: "Ordenar",
  cards_sort_newest: "Mais recentes",
  cards_sort_oldest: "Mais antigas",
  cards_sort_balance_high: "Maior saldo",
  cards_sort_balance_low: "Menor saldo",
  cards_search_placeholder: "Buscar alias, ··últ. 4…",
  cards_balance_own: "Saldo próprio",
  cards_balance_pocket_prefix: "Compartimento · ",
  cards_label_balance_card: "Saldo do cartão",
  cards_label_balance_pocket: "Saldo do compartimento",
  cards_label_month_spend: "Gasto neste mês",
  cards_label_shared_among: "compartilhado entre {{n}} cartões",
  cards_type_virtual_short: "VRT",
  cards_type_fisica_short: "FÍS",
  cards_list_empty_title: "Sem cartões",
  cards_list_empty_description:
    "Não encontramos cartões com os filtros aplicados. Tente limpar a busca ou criar um novo.",
  cards_status_active: "Ativo",
  cards_status_frozen: "Congelado",
  cards_status_disabled: "Desabilitado",
  cards_status_deleted: "Excluído",
  cards_status_pending_review: "Pendente",
  card_detail_export: "Exportar",
  card_detail_tab_overview: "Resumo",
  card_detail_tab_transactions: "Movimentos",
  card_detail_tab_details: "Dados sensíveis",
  card_detail_tab_controls: "Controles",
  card_detail_tab_coming_soon_title: "Em breve",
  card_detail_tab_coming_soon_description: "Esta seção está em construção.",
  card_detail_action_reveal_show: "Mostrar",
  card_detail_action_reveal_hide: "Ocultar",
  card_detail_action_freeze: "Congelar",
  card_detail_action_unfreeze: "Ativar",
  card_detail_action_cancel: "Desabilitar",
  card_detail_action_cancel_coming_soon:
    "Em breve: você poderá desabilitar o cartão. Esta ação é permanente e irreversível.",
  card_detail_action_email_cardholder: "Enviar ao titular",
  card_detail_email_modal_title: "Enviar dados do cartão",
  card_detail_email_modal_description:
    "Vamos enviar ao titular um link seguro para ver os dados completos do cartão.",
  card_detail_email_modal_security_note: "O link é de uso único e expira em 15 minutos.",
  card_detail_email_modal_body:
    "Estamos prestes a enviar os dados completos do cartão ao titular. Deseja continuar?",
  card_detail_email_button_confirm: "Enviar link",
  card_detail_email_button_cancel: "Cancelar",
  card_detail_email_two_factor_title: "Confirme com seu código 2FA",
  card_detail_email_two_factor_description:
    "Digite o código do seu aplicativo autenticador para enviar o e-mail.",
  card_detail_email_success: "Um link seguro foi enviado ao titular.",
  card_detail_email_error: "Não foi possível enviar o e-mail com os dados do cartão.",
  card_detail_email_error_no_email: "Este cartão não tem um e-mail do titular cadastrado.",
  card_detail_more_options: "Mais opções",
  card_detail_menu_delete: "Excluir cartão",
  card_delete_modal_title: "Excluir cartão",
  card_delete_modal_description: 'Você vai excluir o cartão "{{name}}".',
  card_delete_warning_title: "Esta ação é irreversível",
  card_delete_warning_body:
    "O cartão é cancelado, para de funcionar na hora e sai da sua lista de cartões. Os movimentos continuam no histórico. Se ele ainda tiver saldo, devolva-o à wallet antes de excluí-lo.",
  card_delete_cancel: "Cancelar",
  card_delete_confirm: "Excluir cartão",
  card_delete_success: "Cartão excluído.",
  card_delete_error: "Não foi possível excluir o cartão. Tente novamente.",
  update_status_modal_irreversible_title: "Esta ação é irreversível",
  update_status_modal_irreversible_body:
    "Desabilitar o cartão é permanente: não pode ser reativado nem recuperado. Se quiser apenas pausá-lo, congele-o.",
  card_detail_info_title: "Informações",
  card_detail_info_type: "Tipo",
  card_detail_info_brand: "Marca",
  card_detail_info_pocket: "Compartimento",
  card_detail_info_holder: "Titular",
  card_detail_info_expires: "Vence",
  card_detail_info_created: "Criado",
  card_detail_overview_spend_month: "Gasto do mês",
  card_detail_overview_loaded_description: "de {{amount}} carregados no cartão",
  card_detail_overview_available_balance: "Saldo disponível · {{amount}}",
  // --- Card detail overview redesign ---
  card_stats_range_7d: "7 dias",
  card_stats_range_30d: "30 dias",
  card_stats_range_90d: "90 dias",
  card_stats_range_mtd: "Mês em curso",
  card_stats_range_ytd: "Ano em curso",
  card_stats_range_aria: "Intervalo de período",
  card_detail_showing_period: "Mostrando dados dos últimos {{label}}",
  card_detail_balance_hero_label: "Saldo disponível",
  card_detail_balance_hero_frozen: "Cartão congelado — não aceita cobranças.",
  card_detail_balance_hero_no_spend: "Sem gastos neste período.",
  card_detail_balance_hero_runway: "No ritmo atual ({{rate}}/dia) dura ~{{days}} dias.",
  card_detail_balance_status_healthy: "Saudável",
  card_detail_balance_status_attention: "Atenção",
  card_detail_balance_status_low: "Saldo baixo",
  card_detail_balance_status_empty: "Sem saldo",
  card_detail_balance_status_frozen: "Congelado",
  card_detail_action_load: "Carregar",
  card_detail_action_move: "Mover",
  card_maintenance_banner_title: "Operações de saldo em manutenção",
  card_maintenance_banner_description:
    "Cargas, retiradas, transferências de saldo e a criação de novos cartões estão temporariamente desabilitadas. Se precisar de ajuda, entre em contato com o suporte.",
  card_retry_issuance_title: "Este cartão ainda não pôde ser emitido",
  card_retry_issuance_description:
    "Os dados do titular já estão salvos. Tente a emissão de novo sem preencher nada outra vez.",
  card_retry_issuance_action: "Tentar emitir de novo",
  card_retry_issuance_success: "Cartão emitido",
  card_retry_issuance_error: "Não conseguimos emitir o cartão. Tente de novo em alguns minutos.",
  card_detail_action_go_to_pocket: "Ir ao bolso",
  card_detail_pocket_link_label: "Bolso",
  card_detail_period_loaded: "Carregado · {{label}}",
  card_detail_period_loaded_count: "{{count}} cargas",
  card_detail_period_spent: "Gasto · {{label}}",
  card_detail_period_spent_count: "{{count}} movimentos",
  card_detail_period_net: "Saldo líquido do período",
  card_detail_period_net_positive: "Acumulando saldo",
  card_detail_period_net_negative: "Drenando saldo",
  card_detail_period_net_flat: "Sem mudanças",
  card_detail_chart_title: "Gastos no tempo",
  card_detail_chart_bucket_day: "Por dia",
  card_detail_chart_bucket_week: "Por semana",
  card_detail_chart_bucket_month: "Por mês",
  card_detail_chart_avg: "Média {{amount}}/dia",
  card_detail_top_merchants_title: "Para onde vai o saldo",
  card_detail_top_merchants_subtitle: "Top 4 · {{label}}",
  card_detail_top_merchants_empty: "Sem gastos neste período.",
  // --- Unified balance modal ---
  balance_modal_title: "Saldo do cartão",
  balance_modal_action_load: "Carregar",
  balance_modal_action_withdraw: "Retirar",
  balance_modal_action_move: "Mover",
  balance_modal_withdraw_all: "Retirar todo o saldo para a carteira",
  balance_modal_amount_label: "Valor",
  balance_modal_amount_helper: "Todos os valores em USD",
  balance_modal_sending_load: "Carregando o cartão…",
  balance_modal_sending_withdraw: "Sacando para a carteira de cartões…",
  balance_modal_sending_move: "Movendo o saldo…",
  balance_modal_sending_all: "Todo o saldo",
  balance_transit_wallet: "Carteira de cartões",
  balance_transit_aria: "{{amount}} a caminho de {{from}} para {{to}}.",
  balance_modal_wallet_balance_label: "Disponível na carteira",
  balance_modal_card_balance_label: "Saldo do cartão",
  balance_modal_target_card_label: "Cartão destino",
  balance_modal_target_card_placeholder: "Escolha um cartão",
  balance_modal_target_empty:
    "Não há outros cartões ativos do mesmo tipo para os quais você possa mover saldo.",
  balance_modal_preset_chip_aria: "Usar {{amount}}",
  balance_modal_submit_load: "Carregar saldo",
  balance_modal_submit_withdraw: "Retirar para a carteira",
  balance_modal_submit_move: "Transferir",
  balance_modal_cancel: "Cancelar",
  balance_modal_load_success: "Carregados {{amount}} no cartão.",
  balance_modal_withdraw_success: "Você retirou {{amount}} para a carteira de cartões.",
  balance_modal_move_success: "Transferidos {{amount}} para o outro cartão.",
  balance_modal_load_error: "Não foi possível carregar o cartão.",
  balance_modal_withdraw_error: "Não foi possível devolver o saldo ao wallet.",
  balance_modal_move_error: "Não foi possível transferir entre cartões.",
  balance_modal_amount_required: "Informe um valor.",
  balance_modal_amount_min: "O valor deve ser maior que $0.",
  balance_modal_amount_over_wallet: "A carteira de cartões não tem saldo suficiente.",
  balance_modal_amount_over_card: "O cartão não tem saldo suficiente.",
  balance_modal_target_required: "Selecione um cartão de destino.",
  card_detail_overview_usage_badge: "{{percent}}% usado",
  card_detail_overview_trend_title: "Tendência · 6 semanas",
  card_detail_overview_trend_delta: "+{{percent}}% vs sem. anterior",
  card_detail_overview_kpi_transactions: "Transações",
  card_detail_overview_kpi_avg_ticket: "Ticket médio",
  card_detail_overview_kpi_merchants: "Comércios únicos",
  card_detail_overview_kpi_declined: "Recusadas",
  card_detail_overview_kpi_period_month: "neste mês",
  card_detail_overview_kpi_period_30d: "últimos 30 dias",
  card_detail_overview_top_merchants_title: "Principais comércios",
  card_topup_modal_open_button: "Adicionar saldo",
  card_topup_modal_title: "Adicionar saldo",
  card_topup_modal_description: "Adicione fundos da sua wallet para usar neste cartão.",
  card_topup_label_amount: "Valor",
  card_topup_label_currency: "Moeda",
  card_topup_wallet_current_balace: "Saldo atual",
  card_balance: "Saldo",
  card_transfer_modal_open_button: "Transferir",
  card_show_data_button: "Ver detalhes",
  card_hide_data_button: "Ocultar detalhes",
  card_transfer_label_amount: "Valor",
  card_transfer_label_from: "De",
  card_transfer_label_to: "Para",
  card_transfer_modal_description: "Transferir saldo para outro cartão",
  card_transfer_modal_title: "Transferir saldo",
  card_transfer_select_card: "Selecionar um cartão",
  card_transfer_toast_success: "Transferência de saldo de {{amount}} {{currency}} realizada.",
  card_topup_toast_success: "Recarga de saldo realizada no valor de {{amount}} {{currency}}.",
  card_withdrawal_modal_open_button: "Subtrair saldo",
  card_withdrawal_modal_title: "Subtrair saldo",
  card_withdrawal_modal_description: "Subtraia saldo deste cartão e devolva-o à sua wallet.",
  card_withdrawal_toast_success: "Subtração de saldo realizada no valor de {{amount}} {{currency}}.",
  // --- Branding / card design customization ---
  branding_button_personalize: "Personalizar",
  branding_page_title: "Personalização da marca",
  branding_page_subtitle: "A visualização segura de todos os cartões da sua organização",
  branding_summary_title: "Configuração atual",
  branding_summary_label_gradient: "Gradiente",
  branding_summary_label_logo: "Logo",
  branding_logo_default_coloca: "Coloca (padrão)",
  branding_logo_custom: "Personalizado",
  branding_preview_alias: "Sua marca · prévia",
  branding_preview_holder: "Empresa",
  branding_loading: "Carregando configuração…",
  branding_gradient_section_title: "Cor de fundo",
  branding_gradient_section_description: "Escolha um gradiente curado. Aplica-se a todos os cartões.",
  branding_logo_section_title: "Logo personalizado",
  branding_logo_section_description: "Aparece no canto oposto ao isotipo da Coloca.",
  branding_logo_uploader_idle: "Arraste seu logo ou clique para enviar",
  branding_logo_uploader_constraints: "SVG, PNG ou JPG · máx 2 MB · fundo transparente recomendado",
  branding_logo_uploading: "Enviando logo…",
  branding_logo_loaded_title: "Logo enviado",
  branding_logo_loaded_description: "Aparece no canto superior direito do cartão.",
  branding_logo_button_replace: "Substituir",
  branding_logo_button_remove: "Remover logo",
  branding_logo_error_format: "Formato não suportado. Use SVG, PNG ou JPG.",
  branding_logo_error_size: "Máximo 2 MB.",
  branding_logo_upload_failed: "Não foi possível enviar o logo.",
  branding_logo_scale_label: "Tamanho do logo",
  branding_button_reset: "Restaurar",
  branding_button_save: "Salvar alterações",
  branding_footer_default: "Você está usando o design padrão.",
  branding_footer_applies_to_all: "Essas mudanças aplicam-se a todos os cartões da organização.",
  branding_saved: "Design salvo.",
  branding_save_failed: "Não foi possível salvar o design.",
  branding_reset_done: "Design restaurado ao padrão da Coloca.",
  branding_reset_failed: "Não foi possível restaurar o design.",
  branding_locked_badge: "Não ativa",
  branding_locked_title: "Personalize o design dos seus cartões",
  branding_locked_description:
    "Escolha um gradiente e envie o logo da sua empresa para a visualização segura dos seus cartões, ao lado da marca Coloca.",
  branding_locked_cta: "A Coloca a ativa por organização: peça para a sua.",
  branding_no_org_title: "Selecione uma organização",
  branding_no_org_description:
    "A personalização é aplicada por organização. Vincule uma organização à sua conta para começar.",
  branding_no_org_description_internal:
    "A personalização é aplicada por organização. Abra uma organização na lista para personalizar seu design.",
  branding_no_org_cta: "Voltar para cartões",
  branding_no_org_cta_internal: "Ver organizações",
  branding_propagation_notice_title: "As mudanças levam ~1 minuto",
  branding_propagation_notice_body:
    "Ao salvar, as novas cores e o logo são aplicados imediatamente aos cartões novos, mas cartões já abertos podem levar até 1 minuto para refletir a mudança. Fechar e reabrir o detalhe do cartão mostra a mudança imediatamente.",
  branding_saved_with_delay:
    "Design salvo. Pode levar até 1 minuto para aparecer em cartões já abertos — feche e reabra o detalhe para vê-lo instantaneamente.",
  branding_logo_uploaded: "Logo enviado. Lembre-se de clicar em Salvar para aplicá-lo.",
  branding_explainer_title: "Onde o seu design aparece",
  branding_explainer_lead:
    "Suas cores e seu logo se aplicam à visualização segura do cartão, a que você mostra pela API.",
  branding_point_iframe_title: "Só na visualização segura (iframe)",
  branding_point_iframe_body:
    "É a visualização com os dados do cartão que você abre pela API com o link de visualização, e a que você vê no detalhe de cada cartão.",
  branding_point_wallets_title: "Apple Pay e Google Pay não mudam",
  branding_point_wallets_body: "O cartão tokenizado nessas carteiras mantém o design padrão da Coloca.",
  branding_point_cobrand_title: "Co-branded com a Coloca",
  branding_point_cobrand_body: "Seu logo fica ao lado da marca Coloca, que sempre aparece no cartão.",
  branding_point_enabled_title: "Ativada por organização",
  branding_point_enabled_on:
    "A Coloca já a ativou para a sua organização. Se for desligada, o cartão volta ao design Coloca e o seu design fica salvo.",
  branding_point_enabled_off: "Ainda não está ativa para a sua organização. Peça à Coloca para ativá-la.",
  branding_point_enabled_staff:
    "Ative em Organizações → Funcionalidades → Personalizar cartão. Desligada, o cartão volta ao design Coloca e o design salvo é mantido.",
  branding_diagram_aria:
    "Seu design muda o cartão na visualização segura que você abre pela API; o cartão no Apple Pay e no Google Pay mantém o design padrão",
  branding_diagram_api: "API",
  branding_diagram_secure_view: "Visualização segura",
  branding_diagram_wallets: "Apple Pay · Google Pay",
  // --- Titulares (Holders) listagem + detalhe ---
  identities_tier_express: "Express",
  identities_tier_express_perk_one_card: "1 cartão virtual",
  identities_tier_express_perk_monthly_cap: "Limite $500 USD/mês",
  identities_tier_verified: "Verificado",
  identities_tier_verified_perk_unlimited_virtual: "Cartões virtuais ilimitados",
  identities_tier_verified_perk_monthly_cap: "Limite $5.000 USD/mês",
  identities_tier_verified_perk_higher_topups: "Recargas mais altas",
  identities_tier_pro: "Pro",
  identities_tier_pro_perk_physical: "Cartões físicos",
  identities_tier_pro_perk_no_cap: "Sem limite mensal",
  identities_tier_pro_perk_funds_origin: "Origem de fundos verificada",
  identities_kyc_approved: "KYC aprovado",
  identities_kyc_pending: "KYC pendente",
  identities_kyc_rejected: "KYC recusado",
  identities_stats_total: "Titulares",
  identities_stats_kyc_approved: "KYC aprovado",
  identities_stats_kyc_pending: "KYC pendente",
  identities_filter_all: "Todos",
  identities_filter_approved: "Aprovados",
  identities_filter_pending: "Pendentes",
  identities_filter_rejected: "Recusados",
  identities_view_list: "Visão lista",
  identities_view_grid: "Visão grade",
  identities_search_placeholder: "Buscar por nome ou documento…",
  identities_search_min_length_hint: "Digite pelo menos {count} caracteres para buscar.",
  identities_empty_title: "Sem titulares",
  identities_empty_description: "Ainda não há titulares cadastrados. Crie o primeiro para começar.",
  identities_empty_filtered_title: "Sem resultados",
  identities_empty_filtered_description: "Nenhum titular corresponde à sua busca ou aos seus filtros.",
  identities_label_cards: "Cartões",
  identities_label_cards_of: "de",
  identities_list_section_title: "Todos os titulares",
  identities_header_new_person_short: "Novo titular",
  identities_header_new_business_short: "Nova empresa",
  identity_detail_label_birthdate: "Nascimento",
  identity_detail_stats_cards_active: "Cartões ativos",
  identity_detail_stats_month_spend: "Gasto este mês",
  identity_detail_kyc_section_title: "Verificação KYC",
  identity_detail_kyc_section_description:
    "Compartilhe este link com o titular para que ele conclua a verificação. Copie-o ou envie por e-mail.",
  identity_detail_kyc_link_placeholder: "Link de verificação",
  identity_detail_kyc_link_valid_until: "Válido até {{date}}",
  identity_detail_kyc_link_expires_in: "Expira em {{time}}",
  identity_detail_kyc_link_expired: "Link expirado",
  identity_detail_kyc_link_empty:
    "Não há um link de verificação válido. Gere um novo para compartilhar com o titular.",
  identity_detail_kyc_btn_generate: "Gerar link",
  identity_detail_kyc_no_recipient:
    "O titular não tem um e-mail registrado, então não há para quem enviar o link. Copie-o e compartilhe por outro meio.",
  identity_detail_kyc_btn_copy: "Copiar",
  identity_detail_kyc_btn_copied: "Copiado",
  identity_detail_kyc_btn_regenerate: "Regenerar link",
  identity_detail_kyc_btn_send_email: "Enviar por e-mail",
  identity_detail_kyc_toast_regenerate_success: "Um novo link de verificação foi gerado.",
  identity_detail_kyc_toast_regenerate_error: "Não foi possível regenerar o link de verificação.",
  identity_detail_kyc_toast_email_success: "E-mail de verificação enviado.",
  identity_detail_kyc_toast_email_error: "Não foi possível enviar o e-mail de verificação.",
  identity_detail_cards_section_title: "Cartões do titular",
  identity_detail_cards_empty: "Ainda não há cartões.",
  identity_detail_movements_section_title: "Movimentos",
  identity_detail_movements_coming_soon_title: "Em breve",
  identity_detail_movements_coming_soon_description: "Estamos preparando a visão de movimentos por titular.",
  identity_detail_coming_soon: "Em breve",
  // --- Unified "Novo titular" modal ---
  identities_header_new_holder: "Novo titular",
  create_holder_modal_title: "Novo titular",
  create_holder_modal_description: "Preencha os dados da pessoa para criar o titular.",
  create_holder_section_personal: "Dados pessoais",
  create_holder_section_address: "Endereço",
  create_holder_birthdate_format: "Formato AAAA-MM-DD (por exemplo 1994-02-17).",
  create_holder_birthdate_placeholder: "Selecione uma data",
  create_holder_birthdate_invalid: "Data inválida. Selecione uma data do calendário.",
  create_holder_phone_invalid_for_country: "Número de telefone inválido para o país selecionado.",
  create_holder_success: "Titular criado.",
  phone_usage_info_button_label: "Para que usamos o telefone?",
  phone_usage_modal_title: "Para que usamos o telefone?",
  phone_usage_modal_intro: "Usamos este número do cartão para:",
  phone_usage_item_3ds:
    "Código de segurança (3DS): nas compras online enviamos um código de uso único por SMS que o titular insere para confirmar o pagamento.",
  phone_usage_item_whatsapp:
    "Notificações por WhatsApp sobre a atividade do cartão (compras, recargas, reembolsos, bloqueios), quando ativadas.",
  phone_usage_modal_note: "Verifique se o número está correto e pode receber SMS e WhatsApp.",
  // --- "Novo cartão" modal redesign ---
  create_card_modal_description:
    "Escolha um titular e (opcionalmente) um bolso, depois crie o cartão. O primeiro carregamento vem depois — o cartão precisa estar Ativo.",
  create_card_no_holder_title: "Crie um titular primeiro",
  create_card_no_holder_description:
    "Para emitir cartões você precisa de pelo menos um titular: a pessoa em cujo nome o cartão é emitido. Crie um aqui mesmo e siga com o cartão, ou vá ao módulo de titulares para gerenciar os que já existem.",
  create_card_no_holder_button: "Ir para titulares",
  // --- Creating a holder from inside the new-card modal ---
  create_card_new_holder_button: "Novo titular",
  create_card_new_holder_title: "Novo titular",
  create_card_new_holder_description: "Crie o titular sem perder os dados do cartão que você já preencheu.",
  create_card_new_holder_submit: "Criar titular",
  create_card_holder_created_title: "Titular criado",
  create_card_holder_created_pending:
    "Ainda falta verificar a identidade. Até concluir, não é possível emitir um cartão.",
  create_card_holder_created_unknown:
    "Não foi possível confirmar o status. Procure-o na lista de titulares antes de criá-lo de novo.",
  create_card_holder_created_view: "Ver titular",
  create_card_holder_created_done: "Entendido",
  create_card_holder_pending_notice_title: "{{name}} ainda não pode receber um cartão",
  create_card_holder_pending_notice_title_unnamed: "O titular ainda não pode receber um cartão",
  create_card_holder_pending_notice_description:
    "A identidade está em verificação. Escolha outro titular para continuar, ou abra o dele para enviar o link de verificação.",
  create_card_label_type: "Tipo de cartão",
  create_card_type_virtual_title: "Virtual",
  create_card_type_virtual_description: "Pronto em segundos. Ideal para assinaturas e ads.",
  create_card_type_physical_title: "Físico",
  create_card_type_physical_description: "Para gastos presenciais. Integração em curso.",
  create_card_label_alias: "Apelido / Finalidade",
  create_card_alias_placeholder: "Ex: Meta Ads · Q2",
  create_card_label_holder: "Titular",
  create_card_search_holder_placeholder: "Buscar por nome ou documento…",
  create_card_change_holder: "Trocar",
  create_card_no_eligible_holders: "Ainda não há titulares. Crie um na visão de titulares.",
  create_card_no_matching_holders: "Sem titulares que correspondam.",
  create_card_holders_none_eligible_title: "Nenhum titular pode receber um cartão ainda",
  create_card_holders_none_eligible_description:
    "Seus titulares aparecem abaixo com o motivo que bloqueia cada um. Para emitir um cartão, a verificação de identidade precisa estar aprovada. Abra-os na visão de titulares para enviar o link de verificação.",
  create_card_label_pocket: "Bolso associado",
  create_card_label_optional: "opcional",
  create_card_no_pockets_hint: "Ainda não há bolsos. O cartão usará o próprio saldo.",
  create_card_search_pocket_placeholder: "Buscar bolso…",
  create_card_pocket_none: "Sem bolso",
  create_card_pocket_none_description: "O cartão usará o próprio saldo.",
  create_card_preview_label: "Pré-visualização",
  create_card_preview_default_alias: "Novo cartão",
  create_card_emission_label: "Emissão",
  create_card_emission_immediate: "Imediata",
  create_card_provisioning_title: "Carga inicial — depois",
  create_card_provisioning_body:
    "O provedor aprovisiona o cartão primeiro. Só é possível carregar saldo depois que estiver Ativo.",
  create_card_success: "Cartão criado. Aprovisionando com o provedor.",
  // --- Bolsos (Pockets) ---
  pockets_error_load: "Erro ao carregar os bolsos",
  pockets_list_section_title: "Todos os bolsos",
  pockets_stats_total: "Bolsos",
  pockets_stats_total_balance: "Saldo total",
  pockets_stats_cards_linked: "Cartões vinculados",
  pockets_stats_month_spend: "Gasto do mês",
  pockets_search_placeholder: "Buscar bolso…",
  pockets_empty_title: "Sem bolsos",
  pockets_empty_description: "Crie um para agrupar cartões por equipe, projeto ou propósito.",
  pocket_edit_button: "Editar",
  pocket_edit_modal_title: "Editar bolso",
  pocket_edit_modal_description: "Atualize o nome, cor ou ícone. O saldo e os cartões vinculados permanecem.",
  pocket_edit_modal_submit: "Salvar alterações",
  pocket_create_modal_title: "Novo bolso",
  pocket_create_modal_description:
    "Agrupe cartões que compartilham o mesmo saldo. A carga inicial é feita depois em outra etapa.",
  pocket_create_modal_submit: "Criar bolso",
  pocket_create_success: "Bolso criado.",
  pocket_create_error: "Não foi possível criar o bolso.",
  pocket_create_no_org: "Você precisa estar em uma organização para criar bolsos.",
  pocket_update_success: "Bolso atualizado.",
  pocket_update_error: "Não foi possível atualizar o bolso.",
  pocket_label_name: "Nome",
  pocket_label_name_placeholder: "Ex: Marketing Performance",
  pocket_label_color: "Cor",
  pocket_label_icon: "Ícone",
  pocket_preview_label: "Pré-visualização",
  pocket_icon_default: "Padrão",
  pocket_icon_travel: "Viagens",
  pocket_icon_marketing: "Marketing",
  pocket_icon_operations: "Operações",
  pocket_icon_saas: "SaaS",
  pocket_icon_shopping: "Compras",
  pocket_icon_gift: "Presentes",
  pocket_icon_food: "Comida",
  pocket_icon_office: "Escritório",
  pocket_icon_team: "Equipe",
  pocket_icon_budget: "Orçamento",
  pocket_detail_back_to_pockets: "Bolsos",
  pocket_detail_hero_balance_label: "Saldo do bolso",
  pocket_detail_hero_shared_with: "compartilhado com {{count}} cartões",
  pocket_detail_hero_outflow: "Gasto do mês",
  pocket_detail_hero_cards: "Cartões",
  pocket_detail_section_cards_title: "Cartões",
  pocket_detail_section_cards_empty: "Ainda não há cartões neste bolso.",
  pocket_detail_section_movements_title: "Movimentos",
  pocket_detail_load_balance: "Carregar bolso",
  pocket_detail_transfer: "Transferir",
  pocket_detail_create_card: "Criar cartão",
  pocket_delete_button: "Excluir",
  pocket_delete_modal_title: "Excluir bolso",
  pocket_delete_modal_description: 'Você vai excluir o bolso "{name}". Esta ação não pode ser desfeita.',
  pocket_delete_warning:
    "Você só pode excluir um bolso com saldo zero e sem cartões vinculados. Se tiver saldo ou cartões, retire os fundos ou remova os cartões primeiro.",
  pocket_delete_confirm: "Excluir bolso",
  pocket_delete_success: "Bolso excluído.",
  pocket_delete_error: "Não foi possível excluir o bolso.",
  cards_pockets_preview_title: "Bolsos",
  cards_pockets_preview_subtitle: "Cartões que compartilham saldo, agrupados por equipe ou propósito.",
  cards_pockets_preview_view_all: "Ver todos",
  // --- Pocket load/withdraw modal + movements ---
  pocket_load_modal_title: "Movimentos do bolso",
  pocket_load_modal_description:
    "Mova saldo entre o saldo principal e este bolso. O provedor processa o movimento imediatamente.",
  pocket_load_mode_topup: "Carregar",
  pocket_load_mode_withdraw: "Devolver",
  pocket_load_submit_topup: "Carregar bolso",
  pocket_load_submit_withdraw: "Devolver ao principal",
  pocket_load_wallet_available: "Disponível: {{amount}}",
  pocket_load_wallet_loading: "Carregando saldo principal…",
  pocket_load_pocket_available: "No bolso: {{amount}}",
  pocket_load_pocket_balance_label: "Saldo do bolso",
  pocket_load_success_topup: "Carregado {{amount}} ao bolso.",
  pocket_load_success_withdraw: "Devolvido {{amount}} ao saldo principal.",
  pocket_load_pending_reconciliation:
    "O movimento foi executado mas a atualização contábil está pendente. Aparecerá em alguns segundos.",
  pocket_load_error: "Não foi possível completar o movimento.",
  pocket_detail_movements_empty_title: "Sem movimentos",
  pocket_detail_movements_empty_description:
    "Quando você carregar saldo ou os cartões vinculados usarem este bolso, os movimentos aparecerão aqui.",
  pocket_load_balance_processing_hint:
    "O saldo pode demorar alguns segundos para refletir enquanto o provedor processa.",

  statement_page_title: "Extrato do cartão",
  statement_back_to_card: "Voltar ao cartão",
  statement_mode_month: "Mês",
  statement_mode_range: "Dias",
  statement_mode_lifetime: "Vida inteira",
  statement_mode_aria: "Período do extrato",
  statement_month_label: "Mês",
  statement_from_label: "De",
  statement_to_label: "Até",
  statement_error_range_invalid: "A data final não pode ser anterior à data inicial.",
  statement_download_pdf: "Baixar PDF",
  statement_loading: "Gerando o extrato…",
  statement_error_load: "Não foi possível gerar o extrato.",
  statement_error_retry: "Tentar novamente",
  statement_notice_truncated_title: "Extrato reduzido",
  statement_notice_truncated_description:
    "Este período tem {{total}} movimentos e o extrato mostra os primeiros {{shown}}. Os totais cobrem o período completo. Escolha um intervalo menor para ver todos.",

  statement_document_title: "Extrato do cartão",
  statement_number_label: "N.º do extrato",
  statement_issued_at_label: "Emitido",
  statement_period_label: "Período",
  statement_period_lifetime: "Desde a abertura",
  statement_period_range: "{{from}} — {{to}}",
  statement_card_label: "Cartão",
  statement_card_type_label: "Tipo",
  statement_continued: "continuação",

  statement_section_holder: "Titular do cartão",
  statement_section_account: "Conta",
  statement_holder_name: "Nome",
  statement_holder_document: "Documento",
  statement_holder_email: "E-mail",
  statement_holder_address: "Endereço",
  statement_account_name: "Razão social",
  statement_account_tax_id: "CNPJ / NIT",
  statement_account_address: "Endereço",
  statement_value_not_available: "Não disponível",
  statement_holder_source_fallback_note:
    "† Os dados do titular vêm do cartão; documento e endereço não estão disponíveis.",

  statement_summary_opening_balance: "Saldo inicial",
  statement_summary_closing_balance: "Saldo final",
  statement_summary_loaded: "Cargas",
  statement_summary_spent: "Gastos",
  statement_summary_net: "Líquido do período",
  statement_summary_available: "Disponível hoje",
  statement_summary_declined: "Recusadas",
  statement_summary_pending: "Pendentes",
  statement_summary_movements_count: "{{count}} movimentos",
  statement_summary_estimated_suffix: "estimado",

  statement_section_movements: "Detalhe dos movimentos",
  statement_table_date: "Data",
  statement_table_reference: "Ref.",
  statement_table_merchant: "Descrição",
  statement_table_category: "Categoria",
  statement_table_type: "Tipo",
  statement_table_amount: "Valor",
  statement_table_total_period: "Total líquido do período",
  statement_table_empty: "Sem movimentos neste período.",
  statement_badge_declined: "Recusada",
  statement_badge_pending: "Pendente",
  statement_badge_reversed: "Revertida",

  statement_footer_issued: "Extrato emitido automaticamente em {{date}}. Não requer assinatura manuscrita.",
  statement_footer_page: "Página {{current}} de {{total}}",
  statement_footnote_reconciliation:
    "¹ Saldo inicial e final calculados a partir dos movimentos registrados; use-os como referência.",
  statement_footnote_truncated: "Mostrando os primeiros {{shown}} de {{total}} movimentos do período.",
  statement_footer_declined_excluded: "Operações recusadas são listadas mas não somam nos totais.",

  card_deposit_title: "Depositar stablecoins",
  card_deposit_subtitle:
    "Recarregue este cartão enviando stablecoins (moedas digitais atreladas ao dólar) para o endereço dele.",
  card_deposit_network_label: "Rede",
  card_deposit_address_label: "Endereço de depósito",
  card_deposit_assets_label: "Ativos aceitos",
  card_deposit_asset_contract: "Contrato: {{address}}",
  card_deposit_copy: "Copiar endereço",
  card_deposit_copied: "Copiado",
  card_deposit_copied_toast: "Endereço copiado",
  card_deposit_qr_alt: "QR code do endereço de depósito na rede {{network}}",
  card_deposit_warning:
    "Envie apenas {{assets}} pela rede {{network}}. Qualquer outro ativo ou rede não é creditado e não pode ser recuperado. Depósito mínimo: 1 USD.",
  card_deposit_error: "Não foi possível carregar o endereço de depósito do cartão. Tente novamente.",
  card_deposit_retry: "Tentar novamente",
  card_deposit_inactive: "Os depósitos não estão disponíveis enquanto o cartão não estiver ativo.",

  // WhatsApp notifications (/app/cards/notifications) — moved out of general Settings.
  notifications_eyebrow: "Produto · Cartões",
  notifications_nav_label: "Avisos por WhatsApp",
  notifications_page_title: "Notificações por WhatsApp",
  notifications_page_subtitle:
    "A Coloca avisa o titular do cartão quando algo relevante acontece nele. Ative cada tipo separadamente; a mudança vale para todos os cartões emitidos pela sua organização.",
  notifications_hero_title: "Avisos ao titular do cartão",
  notifications_hero_sub:
    "Melhora a segurança e a confiança do titular: ele fica sabendo de cada movimento na hora, sem precisar abrir o app.",
  notifications_footnote: "O aviso é enviado ao telefone registrado na identidade do titular de cada cartão.",

  notifications_topup_name: "Recarga de cartão",
  notifications_topup_desc: "Avisa o titular quando o cartão recebe saldo.",
  notifications_topup_when: "Quando um cartão recebe uma recarga creditada.",
  notifications_declined_name: "Compra recusada",
  notifications_declined_desc:
    "Avisa o titular quando uma compra é recusada (saldo insuficiente, suspeita de fraude, etc.).",
  notifications_declined_when: "Quando uma compra com o cartão é recusada.",
  notifications_reversed_name: "Compra estornada",
  notifications_reversed_desc:
    "Avisa o titular quando um estabelecimento estorna uma compra e o dinheiro volta ao cartão.",
  notifications_reversed_when: "Quando um estabelecimento estorna uma compra.",
  notifications_refund_name: "Reembolso recebido",
  notifications_refund_desc: "Avisa o titular quando um reembolso é creditado no cartão.",
  notifications_refund_when: "Quando um reembolso é creditado no cartão.",
  notifications_blocked_name: "Cartão bloqueado",
  notifications_blocked_desc: "Avisa o titular quando o cartão é bloqueado ou desabilitado.",
  notifications_blocked_when: "Quando o cartão é bloqueado ou desabilitado.",
  notifications_unblocked_name: "Cartão desbloqueado",
  notifications_unblocked_desc: "Avisa o titular quando o cartão volta a ficar ativo depois de um bloqueio.",
  notifications_unblocked_when: "Quando um cartão bloqueado volta a ficar ativo.",
  notifications_withdrawal_name: "Retirada de saldo",
  notifications_withdrawal_desc:
    "Avisa o titular quando o saldo do cartão é retirado para a carteira da organização.",
  notifications_withdrawal_when: "Quando o saldo do cartão é retirado.",
  notifications_balance_low_name: "Saldo baixo",
  notifications_balance_low_desc:
    "Avisa o titular quando o saldo do cartão cai abaixo do limite que você definir.",
  notifications_balance_low_when: "Quando o saldo do cartão cai abaixo do limite que você definir.",
  notifications_balance_low_threshold_label: "Limite de saldo baixo",
  notifications_balance_low_threshold_help:
    "Valor em USD. Se o saldo de um cartão cair abaixo deste valor após uma compra, o alerta é enviado.",
  notifications_balance_low_threshold_required_error:
    "Defina um limite positivo em USD antes de ativar o aviso.",
  notifications_balance_low_threshold_prefix: "USD",
  notifications_approved_name: "Compra aprovada",
  notifications_approved_desc:
    "Avisa o titular a cada compra aprovada, uma única vez por compra. Gera muito volume: ative só se seus clientes pediram.",
  notifications_approved_when: "Quando uma compra com o cartão é aprovada.",
  notifications_approved_opt_in_tag: "OPT-IN",

  notifications_enable_confirm_title: "Ativar o aviso «{{name}}»?",
  notifications_enable_confirm_intro:
    "Ao ativar, a Coloca começa a enviar mensagens reais aos titulares dos seus cartões.",
  notifications_enable_confirm_who_title: "Quem recebe?",
  notifications_enable_confirm_who_body: "O telefone registrado na identidade do titular de cada cartão.",
  notifications_enable_confirm_when_title: "Quando?",
  notifications_enable_confirm_reversible:
    "Você pode desativar a qualquer momento — não afeta cartões já emitidos.",
  notifications_enable_confirm_button: "Sim, ativar",
  notifications_enable_confirm_cancel: "Cancelar",

  notifications_bubble_topup_body:
    "Hola Cliente, tu recarga de $ 50.000 a la tarjeta terminada en 4321 se procesó exitosamente.\n\nFecha: 21 de mayo de 2026 a las 14:30\nSaldo actual: $ 250.000\nID de transacción: TXN-A8K2R9\n\nGracias por usar Coloca Payments.",
  notifications_bubble_declined_body:
    "Tu compra de USD 3,72 en Netflix no se aprobó.\nMotivo: Fondos insuficientes\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\n¿No fuiste tú? Escríbenos por aquí.",
  notifications_bubble_reversed_body:
    "El comercio reversó tu compra de COP 14.000 en Good One Lab.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\nEl dinero ya volvió a tu saldo.",
  notifications_bubble_refund_body:
    "Recibiste un reembolso de BRL 14,00 de Uber.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\nEl saldo ya está disponible.",
  notifications_bubble_blocked_body:
    "Tu tarjeta Coloca •••• 8707 quedó bloqueada.\nMotivo: Varios intentos fallidos de PIN\nSi no fuiste tú quien la bloqueó, escríbenos por aquí.",
  notifications_bubble_balance_low_body:
    "Tu saldo disponible bajó de USD 500,00.\nSaldo actual: USD 438,25\nTarjeta Coloca •••• 8707\nPuedes recargar desde la app de Coloca.",
  notifications_bubble_approved_body:
    "Pagaste COP 14.000 en Good One Lab.\nTarjeta Coloca •••• 8707 · 5 oct 2026 · 1:11 p. m.\n¿No la reconoces? Escríbenos por aquí.",
  notifications_bubble_unblocked_body:
    "Tu tarjeta Coloca •••• 8707 quedó desbloqueada.\n\nYa puedes usarla de nuevo.",
  notifications_bubble_withdrawal_body:
    "Se retiraron USD 120,00 de tu tarjeta Coloca •••• 8707.\nSaldo actual: USD 318,25\n5 oct 2026 · 1:11 p. m.\n\n¿No reconoces este movimiento? Escríbenos por aquí.",
  notifications_bubble_declined_title: "Compra rechazada",
  notifications_bubble_reversed_title: "Compra reversada",
  notifications_bubble_refund_title: "Reembolso recibido",
  notifications_bubble_blocked_title: "Tarjeta bloqueada",
  notifications_bubble_unblocked_title: "Tarjeta desbloqueada",
  notifications_bubble_withdrawal_title: "Retiro de saldo",
  notifications_bubble_balance_low_title: "Saldo bajo",
  notifications_bubble_approved_title: "Compra aprobada",
  notifications_bubble_recipient_hint: "Enviado ao telefone do titular",
  cop_top_up_unavailable_permission: "Seu usuário não tem permissão para recarregar cartões com pesos.",
  cop_top_up_unavailable_card: "Este cartão não recebe recargas com pesos.",
  cop_top_up_unavailable_card_inactive: "O cartão precisa estar ativo.",
  cop_top_up_unavailable_crypto_off: "Cripto não está ativo para sua organização.",
  cop_top_up_unavailable_breb_key: "Crie sua chave Bre-B para usar seus pesos.",
  cop_top_up_unavailable_verification: "Conclua a verificação da sua organização.",
  cop_top_up_unavailable_fee: "Não conseguimos ler a tarifa do cartão. Tente em alguns minutos.",
  cop_top_up_unavailable_generic: "Indisponível no momento.",
  cop_top_up_title: "Recarregar com pesos",
  cop_top_up_description: "Usamos seu saldo em pesos para recarregar o cartão •••• {{last4}}.",
  cop_top_up_step_amount: "Valor",
  cop_top_up_step_review: "Revisar",
  cop_top_up_step_result: "Envio",
  cop_top_up_pay_label: "Você paga",
  cop_top_up_credit_label: "Chega ao cartão",
  cop_top_up_balance: "Disponível: {{amount}}",
  cop_top_up_limits: "A partir de {{min}} por recarga",
  cop_top_up_issue_below_min: "O mínimo é {{min}}.",
  cop_top_up_issue_above_max: "O máximo é {{max}}.",
  cop_top_up_issue_balance: "Seu saldo em pesos não é suficiente.",
  cop_top_up_issue_precision: "Verifique as casas decimais do valor.",
  cop_top_up_issue_invalid: "Digite um valor válido.",
  cop_top_up_pricing: "Calculando…",
  cop_top_up_type_amount: "Digite quanto quer pagar ou quanto deve chegar ao cartão.",
  cop_top_up_trail_pesos: "Seus pesos",
  cop_top_up_trail_usdt: "Viajam como USDT",
  cop_top_up_trail_card: "Cartão •••• {{last4}}",
  cop_top_up_row_pay: "Você paga",
  cop_top_up_row_price: "Preço por dólar",
  cop_top_up_row_sent: "Enviados ao cartão",
  cop_top_up_row_fee: "Tarifa de recarga do cartão ({{percent}} %)",
  cop_top_up_row_returned: "Devolvido à sua carteira",
  cop_top_up_row_credit: "Chega ao cartão",
  cop_top_up_row_paid: "Você pagou",
  cop_top_up_row_sent_done: "Enviados ao cartão",
  cop_top_up_row_credited: "Chegou ao cartão",
  cop_top_up_rate_hint: "Tudo incluído: o que você pagou dividido pelo que chegou ao cartão.",
  cop_top_up_rate_estimated_hint: "Estimada, tudo incluído: confirmada quando o cartão creditar.",
  cop_top_up_approx_note: "O que chega é uma estimativa: o cartão desconta a tarifa ao creditar.",
  cop_top_up_irreversible: "Depois de confirmada, a recarga não pode ser desfeita.",
  cop_top_up_review: "Revisar",
  cop_top_up_back: "Voltar",
  cop_top_up_confirm: "Recarregar {{amount}}",
  cop_top_up_cancel: "Cancelar",
  cop_top_up_close: "Fechar",
  cop_top_up_refresh_price: "Atualizar preço",
  cop_top_up_price_expired: "O preço expirou. Atualize-o para continuar.",
  cop_top_up_ticket_label: "Sua recarga",
  cop_top_up_two_factor_description: "Confirme a recarga de {{amount}} no cartão •••• {{last4}}.",
  cop_top_up_two_factor_required: "Ative a verificação em duas etapas para recarregar cartões.",
  cop_top_up_status_processing_title: "Estamos enviando sua recarga",
  cop_top_up_status_processing_body:
    "Convertemos seus pesos e enviamos ao cartão. Costuma levar alguns minutos.",
  cop_top_up_status_delivered_title: "Já chegou ao cartão",
  cop_top_up_status_delivered_body: "O cartão credita o saldo assim que confirma o depósito.",
  cop_top_up_status_credited_title: "Pronto, o cartão tem o saldo",
  cop_top_up_status_credited_body: "{{amount}} foram creditados no cartão •••• {{last4}}.",
  cop_top_up_status_failed_title: "Não foi possível recarregar",
  cop_top_up_status_failed_body: "Devolvemos os pesos à sua carteira.",
  cop_top_up_keep_going: "Você pode fechar esta janela: a recarga continua.",
  cop_top_up_transit_wallet: "Carteira COP",
  cop_top_up_transit_card: "Cartão",
  cop_top_up_transit_aria:
    "Seus pesos saem da carteira COP, a Coloca os converte em USDT e eles viajam pela {{network}} até o cartão •••• {{last4}}.",
  cop_top_up_error_generic: "Não foi possível criar a recarga.",
  cop_top_up_error_unconfirmed:
    "Não recebemos resposta e a recarga pode ter sido feita. Antes de deixar você fazer outra, verificamos o que aconteceu com esta: assim nunca se cobra duas vezes.",
  cop_top_up_check_unconfirmed: "Verificar a recarga",
  cop_top_up_check_pending: "Ainda não temos a resposta. Verifique de novo em alguns segundos.",
  cop_top_up_check_not_placed:
    "A recarga anterior não foi feita e você não foi cobrado. Você pode cotar de novo.",
  cop_top_up_vanished: "Esta recarga foi recusada antes da compra: não foi feita e você não foi cobrado.",
  cop_top_up_start_over: "Cotar de novo",
  txn_type_deposit_cop: "Recarga com pesos",
  card_wallet_invite_eyebrow: "Carteira de cartões",
  card_wallet_invite_title: "Precisa retirar saldo dos seus cartões?",
  card_wallet_invite_body: "Um saldo em dólares que conecta todos os seus cartões.",
  card_wallet_invite_cta: "Conhecer a carteira",
  card_wallet_invite_status: "Não ativada",
  card_wallet_invite_steps_label: "Como funciona",
  card_wallet_invite_step_withdraw: "Retire saldo de um cartão",
  card_wallet_invite_step_hold: "Fica na carteira",
  card_wallet_invite_step_load: "Passe para outro na hora",
  card_wallet_invite_dismiss: "Agora não",
  card_wallet_invite_dismissed_title: "Pronto, você não verá mais este aviso",
  card_wallet_invite_dismissed_body:
    "Se depois precisar retirar saldo dos seus cartões, ative a carteira em Configurações.",
  card_wallet_invite_dismissed_action: "Ir para Configurações",
  card_wallet_enable_title: "Carteira de cartões",
  card_wallet_enable_lead: "Um saldo em dólares que conecta todos os seus cartões.",
  card_wallet_enable_point_withdraw_title: "Retire saldo de qualquer cartão",
  card_wallet_enable_point_withdraw_body: "O que você retira volta para a carteira e fica disponível.",
  card_wallet_enable_point_load_title: "Recarregue cartões na hora",
  card_wallet_enable_point_load_body:
    "Passe saldo da carteira para um cartão em segundos, sem tarifa de depósito.",
  card_wallet_enable_point_total_title: "Todo o seu saldo em um só lugar",
  card_wallet_enable_point_total_body: "Veja quanto há na carteira e quanto em cada cartão.",
  card_wallet_enable_funding_note:
    "O saldo entra na carteira quando você retira de um cartão ou quando a Coloca faz uma recarga.",
  card_wallet_enable_permanent_note: "Depois de ativada, só o suporte pode desativá-la.",
  card_wallet_enable_cta: "Ativar carteira de cartões",
  card_wallet_enable_cancel: "Agora não",
  card_wallet_enable_success_title: "Carteira de cartões ativa",
  card_wallet_enable_success_body: "Agora você pode retirar saldo dos cartões e recarregá-los pela carteira.",
  card_wallet_enable_done: "Pronto",
  card_wallet_enable_error: "Não foi possível ativar a carteira de cartões. Tente novamente.",
  card_wallet_enable_no_permission: "Peça a um administrador da sua organização para ativá-la.",
  card_wallet_diagram_aria: "A carteira de cartões no centro, com saldo indo e voltando dos seus cartões",
  card_wallet_diagram_wallet: "Carteira",
  first_card_eyebrow: "Seu primeiro cartão",
  first_card_title: "Crie seu primeiro cartão",
  first_card_body:
    "Ele sai em nome de uma pessoa ou empresa e você o gerencia por aqui. Isto é o que você precisa:",
  first_card_step_security_title: "Um método de segurança",
  first_card_step_security_body:
    "Um PIN de segurança ou o app autenticador. Com ele você confirma a emissão e vê os dados do cartão.",
  first_card_step_holder_title: "Um titular verificado",
  first_card_step_holder_body:
    "A pessoa ou empresa em cujo nome o cartão é emitido. Você pode criá-lo ao emitir o cartão; ele precisa concluir a verificação de identidade antes de recebê-lo.",
  first_card_step_balance_title: "Saldo para usá-lo",
  first_card_step_balance_body: "Depois de emitido, você o carrega e ele fica pronto para pagar.",
  first_card_status_done: "Pronto",
  first_card_status_in_review: "Em verificação",
  first_card_status_pending: "Pendente",
  first_card_status_after: "Depois de emitir",
  first_card_cta: "Criar meu primeiro cartão",
  first_card_holders_link: "Ver titulares",
  first_card_diagram_security: "Segurança",
  first_card_diagram_holder: "Titular",
  first_card_diagram_balance: "Saldo",
  first_card_diagram_card: "Seu cartão",
  first_card_diagram_aria:
    "Com um método de segurança e um titular verificado o cartão é emitido; depois é carregado com saldo e fica pronto",
  card_load_title: "Recarregar cartão",
  card_load_description: "Cartão •••• {{last4}}",
  card_load_step_source: "Como",
  card_load_step_details: "Detalhes",
  card_load_source_heading: "Como você quer recarregar?",
  card_load_source_cop: "Com pesos",
  card_load_source_cop_hint: "Use seu saldo em pesos. Chega em cerca de {{minutes}} min.",
  card_load_source_cop_hint_plain: "Use seu saldo em pesos; o cartão recebe em dólares.",
  card_load_source_cop_balance: "Disponível: {{amount}}",
  card_load_source_crypto: "Enviando cripto",
  card_load_source_crypto_hint: "USDT ou USDC pela rede Polygon. Costuma levar de 2 a 10 min.",
  card_load_source_wallet: "Da carteira de cartões",
  card_load_source_wallet_hint: "Na hora · Disponível {{amount}}",
  card_load_source_wallet_hint_plain: "Na hora, com o saldo da carteira",
  card_load_no_withdraw_notice:
    "O que você recarregar fica no cartão: não pode ser retirado, só movido para outro dos seus cartões.",
  card_load_empty_title: "Este cartão ainda não tem como ser recarregado",
  card_load_empty_body: "Fale com o suporte e ativamos a recarga com pesos ou cripto para sua organização.",
  card_load_error: "Não foi possível ver as formas de recarga deste cartão.",
  card_load_retry: "Tentar novamente",
  card_load_continue: "Continuar",
  card_load_cancel: "Cancelar",
  card_load_back: "Voltar",
  card_load_close: "Fechar",
  card_load_unavailable_crypto_off: "A recarga com cripto ainda não está ativa para sua organização.",
  card_load_unavailable_card_inactive: "O cartão precisa estar ativo.",
  card_load_unavailable_card: "Este cartão não aceita essa forma de recarga.",
  card_load_unavailable_generic: "Indisponível no momento.",
  card_load_crypto_next_title: "O que acontece depois",
  card_load_crypto_next_send: "Você envia USDT ou USDC para este endereço, pela rede Polygon",
  card_load_crypto_next_confirm: "A rede confirma a transação",
  card_load_crypto_next_credit: "É creditado no seu cartão, menos a tarifa de depósito",
  card_load_crypto_eta: "Costuma levar de 2 a 10 minutos.",
  card_load_timeline_aria: "Andamento da recarga",
  card_load_stage_debited: "Pesos debitados",
  card_load_stage_sending: "Comprando USDT e enviando",
  card_load_stage_arrived: "Chegou ao seu cartão",
  card_load_stage_credited: "Creditado no seu cartão",
  card_load_stage_failed: "A compra falhou; devolvemos seus pesos",
  card_load_stage_state_done: "Concluído",
  card_load_stage_state_active: "Em andamento",
  card_load_stage_state_pending: "Pendente",
  card_load_stage_state_failed: "Falhou",
  card_detail_receive_crypto_title: "Receber cripto",
  card_detail_receive_crypto_body: "Ver o endereço para enviar USDT ou USDC a este cartão.",
  card_detail_action_withdraw: "Retirar",
  cop_top_up_ack_no_withdraw:
    "Entendo que este saldo não pode ser retirado do cartão; só posso movê-lo para outro dos meus cartões.",
  balance_modal_move_all: "Mover todo o saldo",
  balance_modal_move_all_hint:
    "Inclui as frações de centavo que as tarifas deixam, para o cartão ficar zerado.",
  balance_modal_move_success_all: "Você moveu todo o saldo para o outro cartão.",
};
